import { Injectable } from '@angular/core';

import { ErrorMessageMap } from '../web-services/error';
import { ErrorMessage } from '../../lib-shared/ErrorMessage';
import { Error, ErrorMap } from '../utils/error';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private generateModal: (text: string) => Promise<boolean> = () => Promise.resolve(false);

  constructor() {
  }

  manageError(body: any) {
    const res = this.hasError(body);
    if (res) {
      this.showModal(body.error);
    }
    return res;
  }

  hasError(body: any): ErrorMessage | null {
    if (body && body.hasOwnProperty('error')) {
      return body.error;
    }
    return null;
  }

  setModal(generateModal: (text: string) => Promise<boolean>) {
    this.generateModal = generateModal;
  }

  async showModal(error: ErrorMessage | Error | string): Promise<boolean> {
    let str: string = error as string;
    if (ErrorMessageMap.has(error as ErrorMessage) && ErrorMessageMap.get(error as ErrorMessage) !== '') {
      str = ErrorMessageMap.get(error as ErrorMessage)!;
    } else if (ErrorMap.has(error as Error) && ErrorMap.get(error as Error) !== '') {
      str = ErrorMap.get(error as Error)!;
    }
    return this.generateModal(str);
  }
}
